import { getFieldArrayError } from '@/src/utils/formUtils';
import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import FormErrorMessage from '../../messages/FormErrorMessage';
import MultipleSelectStyled, {
  MultipleSelectStyledProps,
} from '../StyledInputs/MultipleSelectStyled';

type FormControlledMultipleDropdownProps = MultipleSelectStyledProps & {
  defaultValue?: string | number | null;
  formID: string;
  rules?: object;
  isFieldArray?: boolean;
};

const FormControlledMultipleDropdown = ({
  defaultValue,
  formID,
  rules,
  isFieldArray,
  ...otherProps
}: FormControlledMultipleDropdownProps) => {
  const {
    control,
    formState: { errors },
  } = useFormContext();

  let fieldError = errors[formID];
  if (isFieldArray) {
    fieldError = getFieldArrayError(formID, errors);
  }

  return (
    <React.Fragment>
      <Controller
        defaultValue={defaultValue}
        control={control}
        name={formID}
        rules={rules}
        render={({ field: { ref, ...otherFields } }) => (
          <MultipleSelectStyled
            id={formID}
            inputRef={ref}
            error={!!fieldError}
            {...otherProps}
            {...otherFields}
          />
        )}
      />
      {fieldError && (
        <FormErrorMessage errorMessage={fieldError.message as string} />
      )}
    </React.Fragment>
  );
};

export default FormControlledMultipleDropdown;
